import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { tc } from 'utils/theme';

export const StyledDiv = styled.div`
  font-size: 14px;
  line-height: 19px;
  letter-spacing: -0.586363px;
  padding: 8px;
  text-align: center;
`;

export const AlertSuccess = styled(StyledDiv)`
  background-color: ${tc('successBackground')};
  color: ${tc('success')};
`;

export const AlertWarning = styled(StyledDiv)`
  background-color: ${tc('warningBackground')};
  color: ${tc('warning')};
`;

export const AlertDanger = styled(StyledDiv)`
  background-color: ${tc('dangerBackground')};
  color: ${tc('danger')};
`;

function Alert({ type, ...props }) {
  switch (type) {
    case 'success':
      return <AlertSuccess {...props} />;
    case 'warning':
      return <AlertWarning {...props} />;
    default:
    case 'error':
    case 'danger':
      return <AlertDanger {...props} />;
  }
}

Alert.propTypes = {
  type: PropTypes.oneOf(['success', 'danger', 'error']),
};

Alert.defaultProps = {
  type: 'error',
};

export default Alert;
